var $d79c3ee2183cb506$exports = {};
$d79c3ee2183cb506$exports = {
    "info": `Infos`,
    "negative": `Erreur`,
    "positive": `Succ\xe8s`
};


export {$d79c3ee2183cb506$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
